import {ClientUserState} from '../../../../shared/scripts/ClientUserState'
import {ViewPopupLogin} from '../../../../shared/scripts/ui_popup/ui_popup_membership_incentive/ViewPopupLogin'
import {UIUtilsEjsVariables} from '../../../../shared/scripts/UIUtilsEjsVariables'
import {setElementOnClick} from '../../../../shared/scripts/ui_utils/DomUtils'
import {replaceLanguageInPath} from '../../../../shared/scripts/ClientI18n'

export class UISidebarController {
    private readonly sidebars: NodeListOf<HTMLDivElement>
    private readonly leaderboardButtons: NodeListOf<HTMLAnchorElement>
    private readonly lobbyButtons: NodeListOf<HTMLAnchorElement>
    private readonly playButtons: NodeListOf<HTMLAnchorElement>
    private readonly storeButtons: NodeListOf<HTMLAnchorElement>
    private readonly profileButtons: NodeListOf<HTMLAnchorElement>
    private readonly logoButtons: NodeListOf<HTMLDivElement>
    private sceneNavigationCallback?: (scene: 'lobby' | 'play') => void
    private logoClickCallback?: () => void

    constructor() {
        this.sidebars = document.querySelectorAll('.new-sidebar') as NodeListOf<HTMLDivElement>
        this.leaderboardButtons = document.querySelectorAll('.new-sidebar-leaderboard') as NodeListOf<HTMLAnchorElement>
        this.lobbyButtons = document.querySelectorAll('.new-sidebar-lobby') as NodeListOf<HTMLAnchorElement>
        this.playButtons = document.querySelectorAll('.new-sidebar-play') as NodeListOf<HTMLAnchorElement>
        this.storeButtons = document.querySelectorAll('.new-sidebar-store') as NodeListOf<HTMLAnchorElement>
        this.profileButtons = document.querySelectorAll('.new-sidebar-profile') as NodeListOf<HTMLAnchorElement>
        this.logoButtons = document.querySelectorAll('.new-sidebar-logo') as NodeListOf<HTMLDivElement>
        this.setActiveStateBasedOnUrl()
        this.setupHashChangeListener()
        this.setupLobbyAndPlayClickHandlers()
        this.setupProfileButtonClickHandler()
    }

    hide() {
        this.sidebars.forEach((sidebar) => {
            sidebar.classList.add('hidden')
        })
    }

    show() {
        this.sidebars.forEach((sidebar) => {
            sidebar.classList.remove('hidden')
        })
    }

    private setActiveStateBasedOnUrl() {
        this.deactivateAllButtons()

        const pathname = window.location.pathname
        const hash = window.location.hash
        const isRoomUrl = pathname == '/' && hash != ''

        if(hash.includes('lobby=1') || isRoomUrl) {
            UISidebarController.activateButton(this.lobbyButtons)
        } else if(hash.includes('mainpage=1')) {
            UISidebarController.activateButton(this.playButtons)
        } else if(pathname.includes('/leaderboard')) {
            UISidebarController.activateButton(this.leaderboardButtons)
        } else if(pathname.includes('/store')) {
            UISidebarController.activateButton(this.storeButtons)
        } else if(pathname.includes('/profile')) {
            UISidebarController.activateButton(this.profileButtons)
        } else if(pathname == '/' || pathname == '') {
            UISidebarController.activateButton(this.playButtons)
        }
    }

    private setupHashChangeListener() {
        window.addEventListener('hashchange', () => {
            this.setActiveStateBasedOnUrl()
        })
    }

    private setupLobbyAndPlayClickHandlers() {
        this.logoButtons.forEach((button) => {
            setElementOnClick(button, () => {
                if(this.logoClickCallback) {
                    this.logoClickCallback()
                }
            })
        })

        this.lobbyButtons.forEach((button) => {
            // eslint-disable-next-line no-restricted-syntax
            button.addEventListener('click', (event) => {
                if(this.sceneNavigationCallback) {
                    event.preventDefault()
                    this.sceneNavigationCallback('lobby')
                }
            })
        })

        this.playButtons.forEach((button) => {
            // eslint-disable-next-line no-restricted-syntax
            button.addEventListener('click', (event) => {
                if(this.sceneNavigationCallback) {
                    event.preventDefault()
                    this.sceneNavigationCallback('play')
                }
            })
        })
    }

    private setupProfileButtonClickHandler() {
        this.profileButtons.forEach((profileButton) => {
            // eslint-disable-next-line no-restricted-syntax
            profileButton.addEventListener('click', (event) => {
                event.preventDefault()

                if(UIUtilsEjsVariables.isUserOnDiscord) return
                const userState = ClientUserState.userState
                if(userState?.isLoggedIn && userState.username) {
                    const profilePath = `/profile/${encodeURIComponent(userState.username)}`
                    window.location.href = replaceLanguageInPath(profilePath, UIUtilsEjsVariables.language)
                    return
                }
                new ViewPopupLogin()
            })
        })
    }

    setSceneNavigationCallback(callback: (scene: 'lobby' | 'play') => void) {
        this.sceneNavigationCallback = callback
    }

    setLogoClickCallback(callback: () => void) {
        this.logoClickCallback = callback
    }

    deactivateAllButtons() {
        this.leaderboardButtons.forEach((button) => {
            button.classList.remove('active')
        })
        this.lobbyButtons.forEach((button) => {
            button.classList.remove('active')
        })
        this.playButtons.forEach((button) => {
            button.classList.remove('active')
        })
        this.storeButtons.forEach((button) => {
            button.classList.remove('active')
        })
        this.profileButtons.forEach((button) => {
            button.classList.remove('active')
        })
    }

    private static activateButton(buttons: NodeListOf<HTMLAnchorElement>) {
        buttons.forEach((button) => {
            button.classList.add('active')
        })
    }

    activateLeaderboard() {
        this.deactivateAllButtons()
        UISidebarController.activateButton(this.leaderboardButtons)
    }

    activateLobby() {
        this.deactivateAllButtons()
        UISidebarController.activateButton(this.lobbyButtons)
    }

    activatePlay() {
        this.deactivateAllButtons()
        UISidebarController.activateButton(this.playButtons)
    }

    activateStore() {
        this.deactivateAllButtons()
        UISidebarController.activateButton(this.storeButtons)
    }

    activateProfile() {
        this.deactivateAllButtons()
        UISidebarController.activateButton(this.profileButtons)
    }
}

